// react
import React, {
  Fragment,
  useEffect,
  useReducer,
  useState,
  useMemo,
  useRef,
} from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { Message } from '../../../components/message/index';
import { Input } from '../../../components/inputs/InputField';
// circular progress
import CircularProgress from '@mui/material/CircularProgress';
// libraries FormData
import FormData from 'form-data';
import imageCompression from 'browser-image-compression';
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
// services
import { completeStudentDataService } from '../../../services/userService';
import { getTourismProgramsService } from '../../../services/universityStructureService';
// validator
import validator from '../../../utils/validator';

/***************************************************************************/
/* Name : StudentDataEnter React Component */
/***************************************************************************/
const StudentDataEnter = React.memo(() => {
  const navigate = useNavigate();
  const [inputCity, setInputCity] = useState('');
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  // redux

  const [studentData, setStudentData] = useState(
    useSelector((state) => state.ui.studentData)
  );
  const [studentObj, setStudentObj] = useState(
    useSelector((state) => state.ui.studentObj)
  );
  const [compressOptiopns, setCompressOptiopns] = useState({
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });
  const [personalPhoto, setPersonalPhoto] = useState(null);
  const [personalPhotoState, setPersonalPhotoState] = useState(false);
  const id = useSelector((state) => state.ui.studentID);
  //
  const studentNameEnRef = useRef(); //1
  const secondPhoneNumberRef = useRef(); //2
  const addressRef = useRef(); //3
  const cityRef = useRef(); //4
  const emailRef = useRef(); //5

  // get id
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // check if studentData is empty
      if (studentData.length === 0) {
        navigate('/');
      } else {
        fillFields();
      }
    })();
  }, []);
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* fill fields */
  /******************************************************************/
  const fillFields = () => {
    // englishName
    studentNameEnRef.current.setInputValue(studentObj?.studentNameEn || '');
    // secondPhoneNumber
    secondPhoneNumberRef.current.setInputValue(studentObj.phone);
    // city
    addressRef.current.setInputValue(studentObj.address);
    // city
    cityRef.current.value = studentObj.city;
    cityRef.current.label = studentObj.city;
    setInputCity(studentObj.city);
    // email
    emailRef.current.setInputValue(studentObj.email);
    // photos
    if (studentObj.isComplete) {
      setPersonalPhoto(studentObj.personalPhoto);
    }
  };

  /******************************************************************/
  /* validate */
  /******************************************************************/
  const validate = () => {
    // studentNameEn
    if (
      !validator.checkEnglishNameValidity(
        studentNameEnRef.current.getInputValue().trim()
      )
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال الاسم باللغة الانجليزية رباعى',
      });
      // activate error
      studentNameEnRef.current.activeError();
      return false;
    } else {
      // deactivate error
      studentNameEnRef.current.clearError();
    }
    // secondPhoneNumber
    if (
      !validator.checkPhoneValidity(
        secondPhoneNumberRef.current.getInputValue().trim()
      )
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال رقم موبيل صالح',
      });
      // activate error
      secondPhoneNumberRef.current.activeError();
      return false;
    } else {
      // deactivate error
      secondPhoneNumberRef.current.clearError();
    }
    // email
    if (
      !validator.checkEmailValidity(emailRef.current.getInputValue().trim())
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال البريد الالكتروني',
      });
      // activate error
      emailRef.current.activeError();
      return false;
    } else {
      // deactivate error
      emailRef.current.clearError();
    }
    // city
    if (inputCity === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال المحافظة',
      });
      return false;
    }
    // address
    if (addressRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال العنوان ',
      });
      // activate error
      addressRef.current.activeError();
      return false;
    } else {
      // deactivate error
      addressRef.current.clearError();
    }
    // personalPhoto
    if (personalPhoto === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة شخصية 4*6 بخلفية بيضاء',
      });
      return false;
    }

    return true;
  };
  /******************************************************************/
  /* enterDataHandler */
  /******************************************************************/
  const enterDataHandler = async (e) => {
    e.preventDefault();
    // validate
    dispatchDashboardStates({ type: 'PENDING' });
    const isValid = validate();

    // validate
    if (isValid) {
      // collect data in formData
      const formData = new FormData();
      formData.append(
        'studentNameEn',
        studentNameEnRef.current.getInputValue()
      ); //1
      formData.append(
        'phone',
        secondPhoneNumberRef.current.getInputValue().trim()
      ); //2
      formData.append('address', addressRef.current.getInputValue().trim()); //3
      formData.append('city', inputCity); //4
      formData.append('email', emailRef.current.getInputValue().trim()); //5

      // photos
      const arrayOfPhotos = [];
      if (personalPhoto.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!personalPhoto?.type?.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage: 'برجاء ادخال صورة شخصية في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'personalPhoto';
        const photo = new File(
          [personalPhoto],
          `${encodeURIComponent(personalPhoto.name)}@-@-@${photoType}`,
          { type: personalPhoto.type }
        );
        arrayOfPhotos.push(photo);
      }
      // append photos
      formData.append('photo', arrayOfPhotos[0]);

      // send data
      const response = await completeStudentDataService(formData, id);
      if (response.status === 'success') {
        dispatchDashboardStates({
          type: 'SUCCESS',
          successMessage: 'تم استكمال البيانات بنجاح',
        });
        // navigate  after 2 seconds
        setTimeout(() => {
          navigate('/dashboard/studentDataView');
        }, 2000);
      } else {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: response.message,
        });
      }
    }
  };

  return (
    <Fragment>
      {<NavHeader title={'استكمال بيانات الطالب'} mode={'title'} />}
      <div className={styles['container']}>
        {
          <div className={styles['inner-container']}>
            <form className={styles['inputs-form']} onSubmit={enterDataHandler}>
              <div className={styles['inputs-nav']}>
                <h2>بيانات الطالب</h2>
              </div>
              <div className={styles['inputs-container']}>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <Input
                      title={'الاسم باللغة الانجليزية رباعى'}
                      ref={studentNameEnRef}
                    />
                    <Input title={'رقم موبيل'} ref={secondPhoneNumberRef} />
                    <Input title={'البريد الالكتروني'} ref={emailRef} />
                  </div>
                </div>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <h2>المحافظة</h2>
                    <select
                      name='city'
                      className={styles['select']}
                      ref={cityRef}
                      onChange={() => setInputCity(cityRef?.current?.value)}
                    >
                      <option value=''>اختر المحافظة</option>
                      <option value='أسوان'>أسوان</option>
                      <option value='أسيوط'>أسيوط</option>
                      <option value='الأسكندرية'>الأسكندرية</option>
                      <option value='الإسماعيلية'>الإسماعيليـة</option>
                      <option value='الأقصر'>الأقصـر</option>
                      <option value='البحر الاحمر'>البحر الاحمـر</option>
                      <option value='البحيرة'>البحـيرة</option>
                      <option value='الجيزة'>الجيزة</option>
                      <option value='الدقهلية'>الدقهلية</option>
                      <option value='السويس'>السويس</option>
                      <option value='الشرقية'>الشرقية</option>
                      <option value='الغربية'>الغربية</option>
                      <option value='الفيوم'>الفيوم</option>
                      <option value='القاهرة'>القاهرة</option>
                      <option value='القليوبية'>القلـيـوبيـة</option>
                      <option value='المنوفية'>المنوفية</option>
                      <option value='المنيا'>المنيا</option>
                      <option value='الوادى الجديد'>الوادى الجديد</option>
                      <option value='بنى سويف'>بنى سـويف</option>
                      <option value='بورسعيد'>بورسعيد</option>
                      <option value='جنوب سيناء'>جنوب سينـاء</option>
                      <option value='دمياط'>دمياط</option>
                      <option value='سوهاج'>سوهاج</option>
                      <option value='شمال سيناء'>شمال سيناء</option>
                      <option value='قنا'>قنا</option>
                      <option value='كفر الشيخ'>كفر الشيخ</option>
                      <option value='مطروح'>مطروح</option>
                    </select>
                    <Input title={'العنوان'} ref={addressRef} />
                  </div>
                </div>
              </div>
              <div className={styles['inputs-nav']}>
                <h2>رفع الملفات</h2>
              </div>
              <div className={styles['inputs-container']}>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <div className={styles['form-control']}>
                      <input
                        type='file'
                        name='personalPhoto'
                        id='personalPhoto'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/png, image/jpeg'
                        onChange={async (e) => {
                          setPersonalPhotoState(true);
                          const imageFile = e.target.files[0];

                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setPersonalPhoto(compressedFile);
                            setPersonalPhotoState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='personalPhoto'>
                          صورة شخصية (يجب ان تكون 4*6 بخلفية بيضاء وبجودة جيدة)
                        </h3>
                        <div>
                          <label htmlFor='personalPhoto'>
                            {personalPhotoState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {personalPhoto && personalPhoto.name !== ''
                              ? personalPhoto.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {!dashboardStates.pending && (
                <button className={styles['btn']}>ادخل البيانات</button>
              )}
              {dashboardStates.pending && (
                <button className={styles['btn']}>
                  <CircularProgress
                    size={20}
                    sx={{
                      color: '#a18a00',
                    }}
                  />
                </button>
              )}
            </form>
          </div>
        }

        {dashboardStates.pending && (
          <Message text={'يتم الان معالجة البيانات'} type='load' />
        )}
      </div>
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StudentDataEnter };
